import React from 'react';
import { useTranslation } from 'react-i18next';
import './HistoryButton.scss';
import { useShowModal } from '../../store/history/historyActions';
import { action } from '@storybook/addon-actions';

const HistoryButton = () => {
  const { t } = useTranslation();
  const openHistory = useShowModal();

  return (
    <div className='history-button'>
      <button
        onClick={(e) => {
          openHistory();
          action('clicked')(e);
        }}
        className='history-button__text'
      >
        {t('my-history')}
      </button>
    </div>
  );
};

export default HistoryButton;
